<template>
    <div>
        <Card title="greeting-code"> 
          <div class="flex justify-center w-full mt-20">
            <qrcode :value="paymentUrl" :options="{ width: 180, errorCorrectionLevel: 'Q' }" />
          </div>
          <InfoUser :data="userDetails" />
          <PaymentDetail isVertical="true" :data="{ import: paymentDetail.import }" />
        </Card>
        <router-link :to="`/${payment.id}`" class="underline font-black text-14 text-white mt-24 mb-50 inline-block"> {{ $t("payment-code-goback") }}</router-link>
    </div>
</template>

<script>
import InfoUser from '@/components/InfoUser.vue'
import PaymentDetail from '@/components/PaymentDetail.vue'
import Card from '@/components/Card.vue'
import linkToPayData from '@/mixins/linkToPayData.js'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import Vue from 'vue'

Vue.component(VueQrcode.name, VueQrcode);

export default {
  name: 'QrCodePage',
  mixins: [linkToPayData],
  components: {
    Card,
    InfoUser,
    PaymentDetail
  },
  methods: {},
  created () {
    this.initPolling()
  }
}
</script>